import { createAppKit } from '@reown/appkit/react'
import { defineChain } from '@reown/appkit/networks'
import { Ethers5Adapter } from '@reown/appkit-adapter-ethers5'

const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID

if (!projectId) {
  throw new Error('REACT_APP_WALLET_CONNECT_PROJECT_ID must be a defined environment variable')
}

export const xdcNetwork = defineChain({
  id: 50,
  caipNetworkId: 'eip155:50',
  chainNamespace: 'eip155',
  name: 'XDC Network',
  nativeCurrency: {
    decimals: 18,
    name: 'XDC',
    symbol: 'XDC',
  },
  rpcUrls: {
    default: { http: ['https://rpc.xsp.finance'] },
    public: { http: ['https://rpc.xsp.finance'] },
  },
  blockExplorers: {
    default: { name: 'XDCScan', url: 'https://xdcscan.com' },
  },
})

export const xdcTestnet = defineChain({
  id: 51,
  caipNetworkId: 'eip155:51',
  chainNamespace: 'eip155',
  name: 'Apothem Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'TXDC',
    symbol: 'TXDC',
  },
  rpcUrls: {
    default: { http: ['https://erpc.apothem.network'] },
    public: { http: ['https://erpc.apothem.network'] },
  },
  blockExplorers: {
    default: { name: 'Apothem Explorer', url: 'https://explorer.apothem.network' },
  },
})

export const reownNetworks = [xdcNetwork, xdcTestnet] as [typeof xdcNetwork, typeof xdcTestnet]

export const reownAppKit = createAppKit({
  adapters: [new Ethers5Adapter()],
  networks: reownNetworks,
  defaultNetwork: xdcNetwork,
  projectId,
  metadata: {
    name: 'XSwap Protocol',
    description: 'XSwap Protocol Interface',
    url: window.location.origin,
    icons: [`${window.location.origin}/favicon.png`],
  },
  features: {
    analytics: false,
  },
  customRpcUrls: {
    'eip155:50': [{ url: 'https://rpc.xsp.finance' }],
    'eip155:51': [{ url: 'https://erpc.apothem.network' }],
  },
})
